// /app/frontend/src/components/StepUpRouteGuard.js
/**
 * Wraps a route so it demands step-up MFA on entry when the given user
 * preference is enabled. If the user cancels, sends them back to /app.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStepUp } from '@/context/StepUpContext';

export const StepUpRouteGuard = ({ prefKey, moduleName, children }) => {
  const { guardIf } = useStepUp();
  const navigate = useNavigate();
  const [passed, setPassed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const ok = await guardIf(prefKey, {
        reason: `Verifica tu identidad para acceder a ${moduleName}.`,
      });
      if (cancelled) return;
      if (ok) {
        setPassed(true);
      } else {
        navigate('/app', { replace: true });
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefKey]);

  if (!passed) return null;
  return children;
};

export default StepUpRouteGuard;
